<template>
    <!--  Todo: Prüfen - Keine Route, keine Methode, welche diese Seite aufruft -->
    <div>
        <Toolbar>
            <template>
                <BackButton :to="__('general.brands')" :href="$route('brands.index')"/>
            </template>
            <template v-slot:right>
                <ToolbarLink
                    :href="$route('brands.edit', {brandUuid: brand.uuid})">
                    <i class="fas fa-pen mr-1"/>
                    Bearbeiten
                </ToolbarLink>
                <ToolbarLink
                    :href="$route('brands.edit.distribution', {brandUuid: brand.uuid})">
                    <i class="fas fa-lock-open mr-1"/>
                    Freigaben
                </ToolbarLink>
            </template>
        </Toolbar>
        <Card>
            <div v-if="!hasSettings">
                <button class="btn btn-primary">Jetzt konfigurieren</button>
            </div>

            <div class="alert alert-success mb-5 p-5" role="alert">
                <h4 class="alert-heading">Automatische Produktdatenimports aktiviert</h4>
                <p>Aww yeah, you successfully read this important alert message. This example text is going to run a bit longer so that you can see how spacing within an alert works with this kind of content.</p>
                <div class="border-bottom border-white opacity-20 mb-5"></div>
                <p class="mb-0">Whenever you need to, be sure to use margin utilities to keep things nice and tidy.</p>
            </div>

            <div>
                <table class="table">
                    <thead>
                    <tr>
                        <th>Gelesen</th>
                        <th class="text-center"><span class="label label-dot mt-n1 mr-2 label-danger" />Fehler</th>
                        <th class="text-center"><span class="label label-dot mt-n1 mr-2 label-info" />Erstellt</th>
                        <th class="text-center"><span class="label label-dot mt-n1 mr-2 label-success" />Aktualisiert</th>
                        <th></th>
                        <th class="text-right">Datum</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="productImport in imports">
                        <td>{{ productImport.read }}</td>
                        <td class="text-center">{{ productImport.skipped }}</td>
                        <td class="text-center">{{ productImport.new }}</td>
                        <td class="text-center">{{ productImport.updated }}</td>
                        <td class="d-flex flex-row justify-content-center">
                            <div class="progress" style="height: 18px; width: 140px;">
                                <div class="progress-bar bg-danger" role="progressbar" :style="`width: ${ratio(productImport.total, productImport.skipped)}%;`"/>
                                <div class="progress-bar bg-info" role="progressbar" :style="`width: ${ratio(productImport.total, productImport.new)}%;`"/>
                                <div class="progress-bar bg-success" role="progressbar" :style="`width: ${ratio(productImport.total, productImport.updated)}%;`"/>
                            </div>
                        </td>
                        <td class="text-right">{{ $localDate(productImport.created_at) }}, {{ $localTime(productImport.created_at) }}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </Card>
    </div>
</template>

<script>
import Toolbar from '@components/Toolbar.vue'
import BackButton from '@components/BackButton.vue'
import ToolbarLink from '@components/ToolbarLink.vue'
import Card from '@components/Cards/Card.vue'

export default {
    components: {Card, ToolbarLink, BackButton, Toolbar},
    props: {
        brand: Object,
        hasSettings: Boolean,
        imports: Array,
    },

    methods: {
        ratio(total, n) {
            return Math.round(n * 100 / total)
        },
    },
}
</script>
